import React from 'react';
import { FormControl, MenuItem, Select, Typography } from '@mui/material';
import { dropDownSelectStyle } from '../ReusableStyles/CommonStyles';

interface WindowFunctionSelectsProps {
  chartType: string;
  rows: { fieldName: string; id: string }[];
  columns: { fieldName: string; id: string }[];
  windowFnValues: any;
  setWindowFnValues: React.Dispatch<React.SetStateAction<any>>;
  propKey: string;
  chartProp: any;
}

const WindowFunctionSelects: React.FC<WindowFunctionSelectsProps> = ({
  chartType,
  rows,
  columns,
  windowFnValues,
  setWindowFnValues,
  propKey,
  chartProp,
}) => {
  //windowFnValues

  // Update individual properties within the object
  const handleChange = (value: any, subOption?: string) => {
    switch (windowFnValues.windowFnOptions) {
      case 'standing':
        if (subOption === 'row') {
          const selected = rows.find((row) => row.id === value);
          setWindowFnValues((prevState: any) => ({
            ...prevState,
            standingRowIndex:
              value === '(Entire Table)' ? -1 : rows.findIndex((row) => row.id === value),
            standingRow: value === '(Entire Table)' ? '(Entire Table)' : (selected?.id ?? value),
          }));
        } else if (subOption === 'column') {
          const selected = columns.find((column) => column.id === value);
          setWindowFnValues((prevState: any) => ({
            ...prevState,
            standingColumnIndex:
              value === '(Entire Table)' ? -1 : columns.findIndex((column) => column.id === value),
            standingColumn: value === '(Entire Table)' ? '(Entire Table)' : (selected?.id ?? value),
          }));
        }
        break;
      case 'sliding':
        if (subOption === 'row') {
          const selected = rows.find((row) => row.id === value);
          setWindowFnValues((prevState: any) => ({
            ...prevState,
            slidingRowIndex:
              value === '(Entire Table)' ? -1 : rows.findIndex((row) => row.id === value),
            slidingRow: value === '(Entire Table)' ? '(Entire Table)' : (selected?.id ?? value),
          }));
        } else if (subOption === 'column') {
          const selected = columns.find((column) => column.id === value);
          setWindowFnValues((prevState: any) => ({
            ...prevState,
            slidingColumnIndex:
              value === '(Entire Table)' ? -1 : columns.findIndex((column) => column.id === value),
            slidingColumn: value === '(Entire Table)' ? '(Entire Table)' : (selected?.id ?? value),
          }));
        }
        break;
      case 'standingsvssliding':
        if (subOption === 'row') {
          const selected = rows.find((row) => row.id === value);

          setWindowFnValues((prevState: any) => ({
            ...prevState,
            standingSlidingRowIndex:
              value === '(Entire Table)' ? -1 : rows.findIndex((row) => row.id === value),
            standingSlidingRow:
              value === '(Entire Table)' ? '(Entire Table)' : (selected?.id ?? value),
          }));
        } else if (subOption === 'column') {
          const selected = columns.find((column) => column.id === value);
          setWindowFnValues((prevState: any) => ({
            ...prevState,
            standingSlidingColumnIndex:
              value === '(Entire Table)' ? -1 : columns.findIndex((column) => column.id === value),
            standingSlidingColumn:
              value === '(Entire Table)' ? '(Entire Table)' : (selected?.id ?? value),
          }));
        }
        break;
    }
  };

  return (
    <>
      <Typography
        sx={{
          fontSize: '12px',
          paddingLeft: '15px',
          fontWeight: '600',
          color: 'rgb(96, 96, 96)',
          marginTop: '5px',
        }}
      >
        {chartType === 'heatmap' || chartType === 'crossTab' || chartType === 'table'
          ? 'per Row'
          : chartType === 'calendar'
            ? 'per Date'
            : 'per Dimension'}
      </Typography>

      <FormControl fullWidth>
        <Select
          disabled={chartProp.properties[propKey].chartAxes[1].fields.length === 0}
          onChange={(e) => handleChange(e.target.value, 'row')}
          value={
            windowFnValues.windowFnOptions === 'standing'
              ? windowFnValues.standingRow
              : windowFnValues.windowFnOptions === 'sliding'
                ? windowFnValues.slidingRow
                : windowFnValues.windowFnOptions === 'standingsvssliding'
                  ? windowFnValues.standingSlidingRow
                  : null
          }
          sx={{ ...dropDownSelectStyle, margin: '3px 15px 0 15px' }}
        >
          <MenuItem value="(Entire Table)" sx={{ fontSize: '12px', padding: '2px 1rem' }}>
            (Entire Table)
          </MenuItem>
          {rows.length > 0
            ? rows.map((row, i) => (
                <MenuItem
                  key={i}
                  value={row.id}
                  sx={{ fontSize: '12px', padding: '2px 1rem' }}
                  selected={
                    i ===
                    (windowFnValues.windowFnOptions === 'standing'
                      ? windowFnValues.standingRowIndex
                      : windowFnValues.windowFnOptions === 'sliding'
                        ? windowFnValues.slidingRowIndex
                        : windowFnValues.windowFnOptions === 'standingsvssliding'
                          ? windowFnValues.standingSlidingRowIndex
                          : -1)
                  }
                >
                  {row.fieldName}
                </MenuItem>
              ))
            : null}
        </Select>
      </FormControl>

      {['heatmap', 'crossTab', 'boxPlot', 'bubbleMap'].includes(chartType) ? (
        <div>
          <Typography
            sx={{
              fontSize: '12px',
              paddingLeft: '15px',
              fontWeight: '600',
              color: 'rgb(96, 96, 96)',
              marginTop: '12px',
            }}
          >
            {chartType === 'boxPlot' ? 'per Distribution' : 'per Column'}
          </Typography>

          <FormControl fullWidth>
            <Select
              disabled={chartProp.properties[propKey].chartAxes[2].fields.length === 0}
              onChange={(e) => handleChange(e.target.value, 'column')}
              value={
                windowFnValues.windowFnOptions === 'standing'
                  ? windowFnValues.standingColumn
                  : windowFnValues.windowFnOptions === 'sliding'
                    ? windowFnValues.slidingColumn
                    : windowFnValues.windowFnOptions === 'standingsvssliding'
                      ? windowFnValues.standingSlidingColumn
                      : null
              }
              sx={{ ...dropDownSelectStyle, margin: '3px 15px 0 15px' }}
            >
              <MenuItem value="(Entire Table)" sx={{ fontSize: '12px', padding: '2px 1rem' }}>
                (Entire Table)
              </MenuItem>
              {columns.length > 0
                ? columns.map((column, i) => (
                    <MenuItem
                      key={i}
                      value={column.id}
                      sx={{ fontSize: '12px', padding: '2px 1rem' }}
                      selected={
                        i ===
                        (windowFnValues.windowFnOptions === 'standing'
                          ? windowFnValues.standingColumnIndex
                          : windowFnValues.windowFnOptions === 'sliding'
                            ? windowFnValues.slidingColumnIndex
                            : windowFnValues.windowFnOptions === 'standingsvssliding'
                              ? windowFnValues.standingSlidingColumnIndex
                              : -1)
                      }
                    >
                      {column.fieldName}
                    </MenuItem>
                  ))
                : null}
            </Select>
          </FormControl>
        </div>
      ) : null}
    </>
  );
};

export default WindowFunctionSelects;
